<template>
    <div class="construction">
        <van-tabs v-model="active" sticky animated swipe-threshold="1">
            <van-tab v-for="(el, index) in Tablist" :key="index">
                <template #title>
                    <span @click="activeClick(el, 'click')" class="constructionSpan">{{ el.name }}</span>
                </template>
                <div v-if="active == 0">
                    <div class="xmzb">
                        <div class="rowStyle">
                            <div class="colStyle">
                                <div class="buleStyle">{{ totalsun }}天</div>
                                <div style="font-size: 11px;">施工天数</div>
                            </div>
                            <div class="colStyle">
                                <div class="buleStyle">{{ ruleForm.energysave }}吨</div>
                                <div style="font-size: 11px;">年节约能耗</div>
                            </div>
                            <div class="colStyle">
                                <div class="buleStyle">{{ ruleForm.reducedischarge }}吨</div>
                                <div style="font-size: 11px;">年减少碳排放</div>
                            </div>
                            <div class="colStyle">
                                <div class="buleStyle redStyle">{{ ruleForm.filewarning }}条</div>
                                <div style="font-size: 11px;">文件预警信息</div>
                            </div>
                        </div>
                        <div class="swipeStyle">
                            <van-swipe :autoplay="3000" :height="200" style="width: 100%;">
                                <van-swipe-item default="1" v-for="(info, index) in menuList" :key="index"
                                    style="border-radius: 6px;">
                                    <div class="zzStyle">
                                        <div v-if="info.mtma03 ? info.mtma03.length < 30 : ''"
                                            style="margin-right: 20px" :class="{ isActive: info.is }">
                                            {{ info.mtma03 }}

                                        </div>
                                        <div class="notice" v-else>
                                            <div class="notice__inner">
                                                <div class="notice__item notice__item-first"> {{ info.mtma03 }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <video v-if="info.mtma04 == '1'" :src="$store.state.baseUrl +
            info.mtma05
            " id="videoPath" ref="audio" poster="../../../assets/mobileImg/ycy-cy-3.png" autoplay loop muted
                                        controls="fasle"
                                        style="width: 100%; height: 100%; object-fit: unset;border-radius: 6px;"></video>
                                    <img v-else-if="info.mtma04 == '2'" :src="$store.state.baseUrl +
            info.mtma05
            " style="width: 100%; height: 100%;border-radius: 6px;" alt />
                                    <div id="MyViewerDiv" v-else-if="info.mtma04 == '3'"
                                        style="width: 100%; height: 100%;">
                                    </div>
                                    <!-- <BimModel v-else-if="info.mtma04 == '3'"
                                        style="width: 100%; height: 97%; position: relative;border-radius: 6px;"
                                        :url="info"></BimModel> -->
                                    <div v-else id="PDFIframe" class="PDFIframe" style="height:100%;overflow: auto;">
                                    </div>
                                </van-swipe-item>
                            </van-swipe>
                        </div>
                        <div class="listStyle">
                            <div class="itemStyle" v-for="item in wraningData">
                                <div class="titleStyle">
                                    <van-icon name="warning-o" color="#f00" style="margin-right: 8px;" />
                                    {{ item.warntime }}
                                </div>
                                <div class="contentStyle">
                                    <div style="margin-left:12px">预警内容：</div>
                                    <!-- :style="{ '-webkit-line-clamp': lineClamp }"  class="heightMAx"-->
                                    <div class="heightMAx">
                                        {{ item.content }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div class="contentDiv1">
                        <van-search
                            v-if="!(active == 1 && dataList.length == 1) && !(active == 2 && dataList.length == 1) && !(active == 6 && dataList.length == 1)"
                            v-model="searchword" show-action placeholder="请输入关键字" @search="sousuoInput_new">
                            <template #action>
                                <div @click="sousuoInput_new">搜索</div>
                            </template>
                        </van-search>
                        <PageHeaderJSYW ref="pageHeader" :menu="dataList" @menu-change="backList">
                        </PageHeaderJSYW>
                    </div>
                    <van-list v-model="loading" :finished="finished" style="overflow-y:auto;height:100%"
                        finished-text="没有更多了" @load="getData_new" :immediate-check="false">
                        <div v-if="active == 6">
                            <van-swipe-cell v-for="(item, index) in TreeList" :key="index">
                                <div class="contentDiv2 flexLR" @click="onClickTabs_new(item)">
                                    <div v-if="item.show" class="flexLR" style="width: 100%;">
                                        <div class="flexLR" style="width: 90%">
                                            <img style="width: 10%;display: block;"
                                                src="../../../assets/mobileImg/问题反馈清单.png" alt="" />
                                            <van-notice-bar style="width: 90%" color="#000" background="#fff"
                                                :scrollable="(item.title ? item.title.length > 15 : '') ? true : false">
                                                <p class="van-color-text-assist">
                                                    {{ item.title }}
                                                </p>
                                            </van-notice-bar>
                                        </div>
                                        <div :style="{ color: item.num != 0 ? 'red' : '#C4C4C4', fontSize: '15px' }">
                                            {{ item.num }}
                                        </div>
                                    </div>
                                    <div v-else class="flexLR" style="width: 100%;">
                                        <div style="width: 75%; justify-content: end">
                                            <!-- :scrollable="(item.title ? item.title.length > 15 : '') ? true : false" -->
                                            <van-notice-bar color="#000" background="#fff" :scrollable="false"
                                                style="width: 100%;padding-left: 0px;text-align: left;">
                                                <p class="van-color-text-assist"
                                                    style="text-overflow: ellipsis; white-space: nowrap;overflow: hidden;width: 100%;">
                                                    {{ item.title ? item.title : item.fname }}
                                                </p>
                                            </van-notice-bar>
                                        </div>
                                        <div style="width: 25%; justify-content: end">
                                            <!-- :scrollable="(item.replayusers ? (item.replayusers.map((i) => i.user04).join('、')).length > 6 : '') ? true : false" -->
                                            <van-notice-bar color="#000" background="#fff" :speed="30"
                                                style="width: 100%;padding-right: 0px;text-align: right;"
                                                :scrollable="(item.replayusers ? (item.replayusers.map((i) => i.user04).join('、')).length > 6 : '') ? true : false">
                                                <p class="van-color-text-assist"
                                                    style="text-overflow: ellipsis; white-space: nowrap;overflow: hidden;width: 100%;">
                                                    {{ item.replayusers.map((i) => i.user04).join('、') }}
                                                </p>
                                            </van-notice-bar>
                                        </div>
                                    </div>
                                </div>
                            </van-swipe-cell>
                        </div>
                        <div v-else>
                            <van-swipe-cell v-for="(item, index) in TreeList" :key="index">
                                <div class="contentDiv2 flexLR" @click="onClickTabs_new(item)">
                                    <div class="flexLR" style="width: 100%;">
                                        <div style="width: 10%;">
                                            <img v-if="item.title" style="display: block; margin-right: 10px"
                                                src="../../../assets/mobileImg/文件夹.png" alt="" />
                                            <img v-else style="display: block; margin-right: 10px"
                                                src="../../../assets/mobileImg/文件.png" alt="" />
                                        </div>
                                        <!-- :scrollable="(item.title ? item.title.length > 15 : item.fname ? item.fname.length > 15 : '') ? true : false" -->
                                        <van-notice-bar :scrollable="false" color="#000" background="#fff"
                                            style="width: 90%;padding:0 8px;">
                                            <p class="van-color-text-assist"
                                                style="text-overflow: ellipsis; white-space: nowrap;overflow: hidden;width: 100%;">
                                                {{ item.title ? item.title : item.fname }}
                                            </p>
                                        </van-notice-bar>
                                    </div>
                                    <van-icon name="arrow" v-if="item.title ? true : false" />
                                </div>
                            </van-swipe-cell>
                        </div>
                    </van-list>
                </div>
            </van-tab>
        </van-tabs>
        <!-- 添加反馈按钮 -->
        <van-sticky v-show="addProblemShow" style="position: absolute; right: 3%; bottom: 30%;z-index: 9999;">
            <div @click="addProblem()" style="
                                width: 50px;
                                height: 50px;
                                background-color: #1890f5;
                                border-radius: 50%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            ">
                <van-icon name="plus" size="30" color="#fff" />
            </div>
        </van-sticky>
    </div>
</template>

<script>
import {
    Getywproinfo,
    GetMultimedia,
    GetYWProWarnList,
    GetYWProTechnologyList,
    GetywproTreeList,
    GetYwFilesList,
    GetYwFeedbackList,
    GetYWProUserAuth,
    ViewYwDrawings,
    TransformYwDrawings
} from "@/api/index";
import PageHeaderJSYW from "@/components/PageHeaderJSYW";
import Pdfh5 from "pdfh5";
import dayjs from "dayjs";
import { time } from "echarts";
export default {
    name: "dd_construction",
    components: {
        PageHeaderJSYW,
    },
    data() {
        return {
            top: null,
            container: null,
            pdfh5: null,
            list: [],
            loading: false,
            show: false,
            finished: true,
            active: 0,
            activeItem: {},
            pageSize: 0,
            Tablist: [
                { name: "项目展板", id: 0 },
                { name: "技术概览", id: 1 },
                { name: "图纸文件", id: 2 },
                { name: "施工过程文件", id: 3 },
                { name: "施工质量问题", id: 4 },
                { name: "隐蔽影像资料", id: 5 },
                { name: "问题反馈清单", id: 6 },
            ],
            ruleForm: {},
            totalsun: "",
            menuList: [
                {
                    butname: "模型展示",
                    is: true,
                    type: "mp4",
                    //   videoPath: "./video/项目之窗.mp4",
                },
                {
                    butname: "项目之窗",
                    is: false,
                    type: "model",
                    //   videoPath: "./video/项目之窗.mp4",
                },
                {
                    butname: "项目图片",
                    is: false,
                    type: "jpg",
                    videoPath: "",
                },
            ],
            wraningData: [],
            // 技术概览
            JSGLInitList: [
                {
                    id: 'JSGL-1',
                    apiType: 2,
                    title: "规范文件",
                },
                {
                    id: 'JSGL-2',
                    apiType: 3,
                    title: "管理文件",
                },
                {
                    id: 'JSGL-3',
                    apiType: 4,
                    title: "评审文件",
                }
            ],
            TZWJInitList: [
                {
                    id: 'TZWJ-1',
                    apiType: 1,
                    title: "施工图纸",
                },
                {
                    id: 'TZWJ-2',
                    apiType: 2,
                    title: "竣工图纸",
                },
            ],
            WTFKInitList: [
                {
                    id: 'WTFK-1',
                    apiType: 0,
                    title: "施工图纸",
                    show: true,
                    num: 0
                },
                {
                    id: 'WTFK-2',
                    apiType: 1,
                    title: "竣工图纸",
                    show: true,
                    num: 0
                },
                {
                    id: 'WTFK-3',
                    apiType: 2,
                    title: "施工过程文件",
                    show: true,
                    num: 0
                },
                {
                    id: 'WTFK-3',
                    apiType: 4,
                    title: "隐蔽影像资料",
                    show: true,
                    num: 0
                }
            ],
            dataList: [],
            TreeList: [],

            //图纸文件
            drawingType: 1,
            treeNode: [],
            activeDataList: [],
            searchword: "",
            // 质量问题
            addProblemShow: false,
            feedbackList0: [],
            feedbackList1: [],
            feedbackList2: [],
            feedbackList4: [],

            feedinfo: null,
            upOrdelUser: [],
            replyUser: [],
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {
        // tab切换时面包屑导航栏改变
        activeClick(item, type) {
            this.active = item.id;
            this.activeItem = item;
            this.dataList = [{
                title: item.name,
                id: item.id
            }]
            localStorage.setItem("active", JSON.stringify(item));
            if (type == 'click') {
                localStorage.removeItem("activeItem");
                localStorage.removeItem("activeDataList");
            }
            // this.list = [];
            this.searchword = "";
            this.addProblemShow = false;
            this.getData_new();
        },
        //建设运维管理----技术概览 获取相关文件列表
        async GetYWProTechnologyList_WJ(type) {
            let res = await GetYWProTechnologyList({
                params: {
                    xid: this.$store.state.pid,
                    type,
                    searchword: this.searchword,
                    pageIndex: 1,
                    pageSize: 99999,
                }
            })
            return res.Data.list;
        },
        // 图纸、过程文件、隐蔽影像树
        async GetywproTreeList_Tree(type) {
            let res = await GetywproTreeList({
                params: {
                    xid: this.$store.state.pid,
                    type,
                    searchword: this.searchword
                }
            })
            return res.Data
        },
        // 文件列表
        async GetYwFilesList_file(type, treeid) {
            let params = {
                fname: this.searchword,
                xid: this.$store.state.pid,
                type: type,
                treeid: treeid,
                pageindex: 1,
                pageSize: 99999,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            let res = await GetYwFilesList(fd)
            return res.Data
        },
        // 查看文件
        wxClick(item, type, show) {
            this.$router.push({
                name: "fileInfo", params: { ...item }, query: { name: item.fname, item: item, show, type },
            });
        },
        // 获取反馈权限
        async GetYWProUserAuthUser_new(type) {
            let params = {
                xid: this.$store.state.pid,
                type,
            };
            let res = await GetYWProUserAuth({ params })
            return res.Data
        },
        // 获取反馈列表
        async GetFeedbackList(type) {
            let params = {
                searchword: this.searchword,
                projectid: this.$store.state.pid,
                type: type,
                status: '-1',
                pageindex: 1,
                pagesize: 99999,
                treeid: 0,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            let res = await GetYwFeedbackList(fd)
            if (res.Data == null) {
                return []
            }
            let arr = res.Data.length > 0 ? res.Data.filter((el) => el.strstatus != "已关闭") : []
            return arr;
        },
        // 发起问题反馈
        async addProblem() {
            if (this.active == 4) {
                let auth = await this.GetYWProUserAuthUser_new(7)
                this.upOrdelUser = auth ? auth.insertuids ? auth.insertuids.split(',').map(Number) : [] : [];
                this.replyUser = auth ? auth.replyuids ? auth.replyuids.split(',').map(Number) : [] : []; //回复人
                if (this.replyUser.length < 1) {
                    this.$Notify({ type: "warning", message: "请联系管理员设置指定处理人！" });
                    return;
                }
                this.$router.push({
                    name: "problemData", params: { ...this.feedinfo }, query: { feed: this.feedinfo, upOrdelUser: this.upOrdelUser, replyUser: this.replyUser, type: 3 },
                });

            } else if (this.active == 5) {
                this.$router.push({
                    name: "hiddenData", params: { ...this.feedinfo }, query: { feed: this.feedinfo, upOrdelUser: this.upOrdelUser, replyUser: this.replyUser, type: 4 },
                });
            }
        },
        // 问题反馈清单查看
        QualityClick(item) {
            this.$router.push({
                name: "projectzb", params: { ...item }, query: { name: item.title, item: item, upOrdelUser: this.upOrdelUser, replyUser: this.replyUser, },
            });
        },
        ProblemDataClick(item) {
            this.$router.push({
                name: "questionzb", params: { ...item }, query: { name: item.title, item: item, replyUser: item.replayusers },
            });
        },
        async GetYwFeedbackListSearch(type, treeid) {
            let params = {
                searchword: this.searchword,
                projectid: this.$store.state.pid,
                type,
                status: '-1',
                pageindex: 1,
                pagesize: 99999,
                treeid
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            //  获取反馈列表
            let file = await GetYwFeedbackList(fd);
            let filenew = [];
            if (file.Data && file.Data.length > 0) {
                file.Data.forEach((item) => {
                    item.fname = item.title
                    delete item.title
                    filenew.push(item)
                })
            }
            return filenew
        },
        // 搜索
        async sousuoInput_new() {
            let item = this.dataList[this.dataList.length - 1]
            //技术概览
            if (this.active == 1) {
                if (this.dataList.length > 1) {
                    this.TreeList = await this.GetYWProTechnologyList_WJ(item.apiType);
                } else {
                    if (this.searchword == '') {
                        this.TreeList = this.JSGLInitList
                    } else {
                        //外层待定
                    }
                }
            }
            //图纸
            if (this.active == 2) {
                if (this.dataList.length > 1) {
                    if (this.searchword == "") {
                        this.onClickTabs_new(item, true)
                    } else {
                        let treeid = this.dataList.length > 2 ? item.id : null
                        this.TreeList = await this.GetYwFilesList_file(this.drawingType, treeid);
                    }
                } else {
                    if (this.searchword == '') {
                        this.TreeList = this.JSGLInitList
                    } else {
                        //外层待定
                    }
                }
            }
            if (this.active == 3) {
                if (this.searchword == '') {
                    this.onClickTabs_new(item, true)
                } else {
                    this.TreeList = await this.GetYwFilesList_file(3, this.dataList.length > 1 ? item.id : null);
                }
            }
            if (this.active == 4) {
                if (this.searchword == '') {
                    this.onClickTabs_new(item, true)
                } else {
                    this.TreeList = await this.GetYwFeedbackListSearch(3, this.dataList.length > 1 ? item.id : 0)
                }
            }
            if (this.active == 5) {
                if (this.searchword == '') {
                    this.onClickTabs_new(item, true)
                } else {
                    this.TreeList = await this.GetYwFilesList_file(4, this.dataList.length > 1 ? item.id : null);
                }
            }
            if (this.active == 6) {
                if (this.dataList.length > 1) {
                    this.TreeList = await this.GetYwFeedbackListSearch(item.apiType, 0);
                } else {

                }
            }
        },
        async getData_new() {
            if (this.active == 0) {
                this.GetwproinfoList()
                this.GetMultimediaList();
                this.GetYWProWarnList_YJ()
            } else if (this.active == 1) {
                this.TreeList = this.JSGLInitList; //技术概览
            } else if (this.active == 2) {
                this.TreeList = this.TZWJInitList; //图纸文件
            } else if (this.active == 3) {
                //施工过程文件
                this.treeNode = await this.GetywproTreeList_Tree(3);
                let parent = this.treeNode.filter((w) => w.parentid === 0).map((item) => {
                    return { ...item, title: item.tname };
                })
                this.TreeList = parent
            } else if (this.active == 4) {
                //施工质量问题
                this.treeNode = await this.GetywproTreeList_Tree(4);
                let parent = this.treeNode.filter((w) => w.parentid === 0).map((item) => {
                    return { ...item, title: item.tname };
                })
                this.TreeList = parent
                //获取回复人
                let auth = await this.GetYWProUserAuthUser_new(7)
                this.upOrdelUser = auth ? auth.insertuids ? auth.insertuids.split(',').map(Number) : [] : [];
                this.replyUser = auth ? auth.replyuids ? auth.replyuids.split(',').map(Number) : [] : []; //回复人
            } else if (this.active == 5) {
                //隐蔽影像
                this.treeNode = await this.GetywproTreeList_Tree(5);
                let parent = this.treeNode.filter((w) => w.parentid === 0).map((item) => {
                    return { ...item, title: item.tname };
                })
                this.TreeList = parent
                //获取回复人
                let auth = await this.GetYWProUserAuthUser_new(8)
                this.upOrdelUser = auth ? auth.insertuids ? auth.insertuids.split(',').map(Number) : [] : [];
                this.replyUser = auth ? auth.replyuids ? auth.replyuids.split(',').map(Number) : [] : []; //回复人
            } else if (this.active == 6) {
                this.TreeList = this.WTFKInitList; //问题反馈清单

                this.feedbackList0 = await this.GetFeedbackList(0);
                this.TreeList[0].num = this.feedbackList0.length;

                this.feedbackList1 = await this.GetFeedbackList(1)
                this.TreeList[1].num = this.feedbackList1.length;

                this.feedbackList2 = await this.GetFeedbackList(2)
                this.TreeList[2].num = this.feedbackList2.length;

                this.feedbackList4 = await this.GetFeedbackList(4)
                this.TreeList[3].num = this.feedbackList4.length;
            }
        },
        async onClickTabs_new(item, back) {
            if (this.active == 1) {
                if ('apiType' in item) {
                    this.TreeList = await this.GetYWProTechnologyList_WJ(item.apiType);
                    this.dataList = [{ title: this.activeItem.name, id: this.activeItem.id }, item];
                    localStorage.setItem("activeItem", JSON.stringify(item));
                    localStorage.setItem("activeDataList", JSON.stringify(this.dataList));
                }
                //文件
                if (item.fname) {
                    this.wxClick(item, null, false)
                }
            }
            if (this.active == 2) {
                if (back && this.activeDataList.length > 0) {
                    if (this.activeDataList.map(i => i.id).includes("TZWJ-1")) {
                        this.treeNode = await this.GetywproTreeList_Tree(1);
                        this.drawingType = 1
                    } else if (this.activeDataList.map(i => i.id).includes("TZWJ-2")) {
                        this.treeNode = await this.GetywproTreeList_Tree(2);
                        this.drawingType = 2
                    }
                }
                // 根节点
                if ('apiType' in item) {
                    this.drawingType = item.apiType;
                    if (!back) {
                        this.dataList = []
                    }
                    this.treeNode = await this.GetywproTreeList_Tree(this.drawingType);
                    let parent = this.treeNode.filter((w) => w.parentid === 0).map((item) => {
                        return { ...item, title: item.tname };
                    })
                    this.TreeList = parent
                    if (!back) {
                        this.dataList = [{ title: this.activeItem.name, id: this.activeItem.id }, item];
                    }
                }
                // 树节点
                if (item.tname) {
                    if (!back) {
                        this.dataList.push(item);
                    }
                    let children = this.treeNode.filter((w) => w.parentid === item.id).map((item) => {
                        return { ...item, title: item.tname };
                    })
                    let file = await this.GetYwFilesList_file(this.drawingType, item.id);
                    this.TreeList = children.concat(file)
                    localStorage.setItem("activeItem", JSON.stringify(item));
                    localStorage.setItem("activeDataList", JSON.stringify(this.dataList));
                }
                //文件
                if (item.fname) {
                    this.wxClick(item, this.drawingType == 1 ? 2 : 4, true)
                }
            }
            if (this.active == 3) {
                this.treeNode = await this.GetywproTreeList_Tree(3);
                if (back && item.title == "施工过程文件") {
                    let parent = this.treeNode.filter((w) => w.parentid === 0).map((item) => {
                        return { ...item, title: item.tname };
                    })
                    this.TreeList = parent
                    localStorage.removeItem("activeItem");
                    localStorage.removeItem("activeDataList");
                }
                // 树节点
                else if (item.tname) {
                    if (!back) {
                        this.dataList.push(item);
                    }
                    let children = this.treeNode.filter((w) => w.parentid === item.id).map((item) => {
                        return { ...item, title: item.tname };
                    })
                    let file = await this.GetYwFilesList_file(3, item.id);
                    this.TreeList = children.concat(file)
                    localStorage.setItem("activeItem", JSON.stringify(item));
                    localStorage.setItem("activeDataList", JSON.stringify(this.dataList));
                }

                //文件
                if (item.fname) {
                    this.wxClick(item, 6, true)
                }
            }
            if (this.active == 4) {
                this.addProblemShow = false;

                this.treeNode = await this.GetywproTreeList_Tree(4);
                if (back && item.title == "施工质量问题") {
                    let parent = this.treeNode.filter((w) => w.parentid === 0).map((item) => {
                        return { ...item, title: item.tname };
                    })
                    this.TreeList = parent
                    localStorage.removeItem("activeItem");
                    localStorage.removeItem("activeDataList");
                }
                // 树节点
                else if (item.tname) {
                    if (!back) {
                        this.dataList.push(item);
                    }

                    let children = this.treeNode.filter((w) => w.parentid === item.id).map((item) => {
                        return { ...item, title: item.tname };
                    })
                    this.TreeList = children

                    let params = {
                        searchword: this.searchword,
                        projectid: this.$store.state.pid,
                        type: 3,
                        status: '-1',
                        pageindex: 1,
                        pagesize: 99999,
                        treeid: item.id
                    };
                    let fd = new FormData();
                    for (var key in params) {
                        fd.append(key, params[key]);
                    }
                    //  获取反馈列表
                    let file = await GetYwFeedbackList(fd);
                    if (file.Data) {
                        // this.$Notify({ type: "warning", message: file.Message });
                        // return;

                        let filenew = [];
                        if (file.Data.length > 0) {
                            file.Data.forEach((item) => {
                                item.fname = item.title
                                delete item.title
                                filenew.push(item)
                            })
                        }
                        this.TreeList = children.concat(filenew)
                        this.feedinfo = item;
                        localStorage.setItem("activeItem", JSON.stringify(item));
                        localStorage.setItem("activeDataList", JSON.stringify(this.dataList));

                        //是否可以添加反馈问题
                        if (this.upOrdelUser.includes(Number(this.$store.state.uid))) {
                            this.addProblemShow = true;
                        }
                    }
                }
                //文件
                else {
                    this.QualityClick(item)
                }
            }
            if (this.active == 5) {
                this.addProblemShow = false;

                this.treeNode = await this.GetywproTreeList_Tree(5);
                if (back && item.title == "隐蔽影像资料") {
                    let parent = this.treeNode.filter((w) => w.parentid === 0).map((item) => {
                        return { ...item, title: item.tname };
                    })
                    this.TreeList = parent
                    localStorage.removeItem("activeItem");
                    localStorage.removeItem("activeDataList");
                }
                // 树节点
                else if (item.tname) {
                    if (!back) {
                        this.dataList.push(item);
                    }
                    let children = this.treeNode.filter((w) => w.parentid === item.id).map((item) => {
                        return { ...item, title: item.tname };
                    })
                    let file = await this.GetYwFilesList_file(4, item.id);
                    this.TreeList = children.concat(file)
                    this.feedinfo = item;
                    localStorage.setItem("activeItem", JSON.stringify(item));
                    localStorage.setItem("activeDataList", JSON.stringify(this.dataList));

                    //是否可以添加反馈问题
                    if (this.upOrdelUser.includes(Number(this.$store.state.uid))) {
                        this.addProblemShow = true;
                    }
                }

                //文件
                if (item.fname) {
                    this.wxClick(item, 9, true)
                }
            }
            if (this.active == 6) {
                if ('apiType' in item) {
                    this.TreeList = await this.GetFeedbackList(item.apiType);
                    this.TreeList.forEach((item) => {
                        item.show = false
                    })
                    this.dataList = [{ title: this.activeItem.name, id: this.activeItem.id }, item];
                    localStorage.setItem("activeItem", JSON.stringify(item));
                    localStorage.setItem("activeDataList", JSON.stringify(this.dataList));
                } else {
                    this.ProblemDataClick(item)
                }
            }

        },
        async backList(item) {
            this.searchword = '';
            this.dataList = item
            let item1 = item[item.length - 1]
            if (this.active == 1) {
                if (item.length > 1) {
                    this.onClickTabs_new(item1, true)
                } else {
                    this.TreeList = this.JSGLInitList;
                    localStorage.removeItem("activeItem");
                    localStorage.removeItem("activeDataList");
                }
            }
            if (this.active == 2) {
                if (item1.title == "图纸文件") {
                    this.TreeList = this.TZWJInitList;
                } else {
                    this.onClickTabs_new(item1, true)
                }

            }
            if (this.active == 3 || this.active == 4 || this.active == 5) {
                this.onClickTabs_new(item1, true)
            }
            if (this.active == 6) {
                if (item.length > 1) {
                    this.onClickTabs_new(item1, true)
                } else {
                    this.TreeList = this.WTFKInitList;

                    localStorage.removeItem("activeItem");
                    localStorage.removeItem("activeDataList");

                    this.feedbackList0 = await this.GetFeedbackList(0);
                    this.TreeList[0].num = this.feedbackList0.length;

                    this.feedbackList1 = await this.GetFeedbackList(1)
                    this.TreeList[1].num = this.feedbackList1.length;

                    this.feedbackList2 = await this.GetFeedbackList(2)
                    this.TreeList[2].num = this.feedbackList2.length;

                    this.feedbackList4 = await this.GetFeedbackList(4)
                    this.TreeList[3].num = this.feedbackList4.length;
                }
            }
        },


        // 项目展板多媒体---------------- -1
        async GetwproinfoList() {
            let res = await Getywproinfo({ params: { xid: this.$store.state.pid } });
            this.ruleForm = res.Data.proinfo;
            this.totalsun = res.Data.sgtian;
        },
        async GetMultimediaList() {
            let res = await GetMultimedia({
                params: { xid: this.$store.state.pid, mtma09: 7, mtma10: 2 },
            });
            if (res.Data) {
                this.menuList = res.Data.map((v) => {
                    return {
                        ...v,
                        is: false,
                    };
                });
                // 给下标为0的对象is变为TRUE
                for (const key in this.menuList) {
                    if (key == 0) {
                        this.menuList[0].is = true;
                    }
                }
                this.menuList.map((v) => {
                    if (v.mtma04 == '4') {
                        setTimeout(() => {
                            new Pdfh5("#PDFIframe2", {
                                pdfurl: this.$store.state.baseUrl + v.mtma05
                            });
                        }, 300)
                    } else if (v.mtma04 == '3') {
                        this.viewers(this.$store.state.baseUrl + v.mtma05);
                    }

                })
            } else {
                this.menuList;
            }
        },
        GetYWProWarnList_YJ() {
            GetYWProWarnList({
                params: {
                    xid: this.$store.state.pid,
                    pageIndex: 1,
                    pageSize: 99999,
                },
            }).then((res) => {
                res.Data.list.forEach(e => {
                    e.warntime = dayjs(e.warntime).format('YYYY-MM-DD HH:mm:ss')
                });
                this.wraningData = res.Data.list;
            });
        },
        viewers(url) {
            var _this = this;
            //初始化
            var config = {
                extensions: [
                    "Autodesk.Viewing.ZoomWindow",
                    // "Autodesk.Viewing.Collaboration",
                ],
                disabledExtensions: {
                    measure: false,
                    section: false,
                },
                memory: {
                    limit: 32 * 1024, //32 GB
                },
            };
            var myViewerDiv = document.getElementById("MyViewerDiv");
            _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
                myViewerDiv,
                config
            );
            var options = {
                document: url,
                language: "zh-HANS",
                env: "Local",
                offline: "true",
                useADP: false,
            };
            Autodesk.Viewing.Initializer(options, function onInitialized() {
                _this.viewer.start();
                _this.viewer.loadModel(options.document, {
                    isAEC: true,
                });
                _this.viewer.setTheme("light-theme");
                _this.viewer.addEventListener(
                    Autodesk.Viewing.TEXTURES_LOADED_EVENT,
                    function (event) {
                        //选择集
                        var json = Params.state.replace(/'/g, '"');
                        var jsonObject = JSON.parse(json);
                        _this.viewer.restoreState(jsonObject);
                    }
                );
            });
        },

        find(list, id) {
            let _this = this;
            let result;
            for (let index = 0; index < list.length; index++) {
                const el = list[index];
                if (el.id == id) {
                    result = el;
                    return result;
                } else if (el.children && el.children.length) {
                    result = _this.find(el.children, id);
                    if (result) {
                        return result;
                    }
                }
            }
            return result;
        },
    },
    created() {
        this.getData_new();
        if (localStorage.getItem("active")) {
            this.activeClick(JSON.parse(localStorage.getItem("active")));
            if (localStorage.getItem("activeItem") && localStorage.getItem("activeDataList")) {
                this.activeDataList = JSON.parse(localStorage.getItem("activeDataList"))
                this.backList(JSON.parse(localStorage.getItem("activeDataList")))
            }
        }
    },
    mounted() {

    },
};
</script>
<style lang="scss" scoped>
.construction {
    position: relative;

    // height: 100%;
    #MyViewerDiv {
        height: 100%;
        width: 100%;
        position: absolute;
    }

    .flexLR {
        img {
            width: 60px;
            height: 60px;
        }
    }

    .menuStyle {
        position: relative;
        width: 90%;
        margin: 0 auto;
        margin-bottom: 40px;
        border-radius: 20px;
        padding: 40px;
        padding-top: 50px;
        min-height: 220px;

        span {
            position: absolute;
            right: 0;
            top: 0;
            display: block;
            width: 150px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            color: white;
            border-radius: 0 20px 0 20px;
            background-color: red;
        }

        .flexcolumn {
            min-height: 220px;
            align-items: flex-start;
            justify-content: space-between;

            .flexLR {
                width: 100%;

                .bd {
                    border: 2px solid rgb(0, 174, 255);
                    color: rgb(0, 174, 255);
                    padding: 0px 10px;
                    border-radius: 30px;
                }

                p {
                    color: #a9a9a9;
                    display: inline-block;
                }
            }
        }
    }

    .xmzb {
        margin: 0 20px;

        .rowStyle {
            width: 100%;
            margin: 20px 0 30px 0;
            display: flex;
            justify-content: space-between;
        }

        .colStyle {
            // width: 24%;
            // height: 1.6rem;
            border-radius: 0.13333rem;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-content: center;
            justify-content: center;
            padding: 18px 25px 18px 15px;
            font-size: 24px;

            .buleStyle {
                font-size: 33px;
                color: #187FF5;
                font-weight: bold;
            }

            .redStyle {
                color: #FF0000;
            }
        }

        .swipeStyle {
            width: 100%;
            // height: 23vh;
            background: #fff;
            position: relative;
            border-radius: 5px;

            .zzStyle {
                position: absolute;
                width: 100%;
                height: 15%;
                z-index: 9;
                overflow-x: auto;
                background-color: rgba(0, 0, 0, 0.1);
                border-radius: 10px 10px 0px 0px;
                color: #fff;
                padding-left: 15px;
                font-size: 24px;
                display: flex;
                align-items: center;
            }
        }

        .listStyle {
            height: 50%;
            // width: 100%;

            .itemStyle {
                margin: 30px 0;
                font-size: 28px;
                // height: 220px;
                border-radius: 10px 10px 0px 0px;
                background: linear-gradient(180deg, #FEDCDC 0%, #FFFFFF 41.32%, #FFFFFF 75.47%);


                .titleStyle {
                    height: 60px;
                    border-radius: 10px 10px 0px 0px;
                    display: flex;
                    align-items: center;
                    padding-left: 20px;
                    border-bottom: 2px solid #fff;
                    font-size: 28px;
                }

                .contentStyle {
                    // height: 170px;
                    padding-bottom: 20px;
                    display: flex;
                    // justify-content: space-between;
                    font-size: 23px;
                    color: rgba(51, 51, 51, 0.8);

                    .heightMAx {
                        width: 74vw;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
            }
        }
    }

    .contentDiv1 {
        // height: 20%;
        background-color: white;
        margin-bottom: 20px;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 6;
    }

    .contentDiv2 {
        height: 100px;
        padding: 20px 40px;
        background-color: white;
        margin-bottom: 5px;
    }

    /deep/ .van-tabs {
        height: 80vh;
    }

    /deep/.van-tab__pane {
        height: 100%
    }

    /deep/ .van-tabs__line {
        background-color: rgb(255, 255, 255);
    }

    /deep/ .van-tabs__nav {
        background-color: rgba(255, 255, 255, 0);
    }

    // /deep/ .van-tab{
    //   background-color: #2e6be6;
    // }
    // /deep/ .van-tabs__nav{
    //   margin-top:-6px;
    // }
    .constructionSpan {
        color: white;
    }

    /deep/ .van-tab__text {
        padding: 0 10px;
    }

    /deep/ .van-tab--active .van-tab__text .constructionSpan {
        position: relative;
        z-index: 1;
        min-width: 62px;
        text-align: center;
        display: block;
        color: rgb(0, 119, 255);

        &::after {
            content: "";
            position: absolute;
            left: -5px;
            z-index: -1;
            top: 0;
            background-color: rgb(255, 255, 255);
            width: 100%;
            padding: 0 5px;
            border-radius: 10px;
            height: 100%;
        }
    }

    /deep/ .van-tabs__content {
        margin-top: 10px;
        height: 89%;
        overflow-y: auto;
    }

    .headTree {
        width: 100%;
        height: 40px;
        overflow: hidden;
        overflow-y: auto;
        background-color: red;
    }

    /deep/ .van-sticky--fixed .van-tabs__nav {
        background-color: #3767ed !important;
    }

    /deep/ .van-sticky--fixed .van-tabs__line {
        opacity: 0;
    }
}
</style>